import Topo from './styles'

const Cabecalho = () => (
  <Topo>
    <h1>EBAC Jobs</h1>
  </Topo>
)

export default Cabecalho
